import { ReactNode, createContext, useContext, useMemo, useState } from 'react';

type QueryContextType = {
    editingQuery: string;
    setEditingQuery: (id: string) => void;
};

const QueriesContext = createContext<QueryContextType>({ editingQuery: '', setEditingQuery: () => {} });

type QueriesAddonProviderProps = {
    children: ReactNode | ReactNode[];
};

export function QueriesAddonProvider({ children }: QueriesAddonProviderProps): JSX.Element {
    const [editingQuery, setEditingQuery] = useState('');

    const value = useMemo(() => ({ editingQuery, setEditingQuery }), [editingQuery]);

    return <QueriesContext.Provider value={value}>{children}</QueriesContext.Provider>;
}

export function useQueriesAddon(): QueryContextType {
    const context = useContext(QueriesContext);
    if (context === undefined) {
        throw new Error('useQueriesAddon must be used within QueriesAddonProvider');
    }
    return context;
}
